import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import LytNavTabs from "./components/lytNavTabs";
import LytAboutPage from "./components/lytPageAbout";
import LytGalleryPage from "./components/lytPageGallery";
import LytHtmlPage from "./components/lytPageHtml";
import LytContactPage from "./components/lytPageContact";
import "./App.scss";
import { PagesData, PageData } from "./interfaces";
import Stack from "@mui/material/Stack";
//import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

const theme = createTheme({
  palette: {
    primary: {
      main: "#c62828",
    },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          borderColor: "#000000", // Outline border
        },
        root: {
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#000000",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#000000",
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "#000000", // Label color
          "&.Mui-focused": {
            color: "#000000",
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: "#000000", // Helper text color
        },
      },
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          color: "#000000", // Input adornment (icons, prefixes, suffixes)
        },
      },
    },
  },
});

interface StateType {
  loadState: String;
  selectedPageData: PageData;
}

class App extends React.Component<{}, StateType> {
  state = {
    loadState: "loading",
    selectedPageData: {
      lable: "test",
      display: "",
      dataSrc: "",
    } as PageData,
  };

  pagesData?: PagesData;
  socialLinks?: any;

  componentDidMount = () => {
    //this.getLangData();
    console.log("lyt ready");
    this.getPageData();
  };

  getPageData = () => {
    return new Promise((resolve, reject) => {
      fetch(`./manifest.json`)
        .then((response) => response.json())
        .then((pagDat: object) => {
          this.pagesData = pagDat as PagesData;
          this.socialLinks = this.pagesData.socialLinks;
          this.setState(
            {
              loadState: "loaded",
              selectedPageData: this.pagesData.pages[0],
            },
            () => {
              resolve(this.state.loadState);
            }
          );
        });
    });
  };

  handlePageNav = (newPageData: PageData) => {
    //console.log(newPageData);
    this.setState({
      selectedPageData: newPageData,
    });
  };

  handleSocLink = (linkId: String) => {
    let linkTo = this.socialLinks[linkId as keyof typeof Object];
    window.open(linkTo, "_blank");
  };

  render() {
    const BuildLytPage = () => {
      if (this.state.selectedPageData.display === "gallery") {
        return (
          <Box className="lytPageWrapper">
            <LytGalleryPage data={this.state.selectedPageData}></LytGalleryPage>
          </Box>
        );
      } else if (this.state.selectedPageData.display === "contact") {
        return (
          <Box className="lytPageWrapper">
            <LytContactPage></LytContactPage>
          </Box>
        );
      } else if (this.state.selectedPageData.display === "about") {
        return (
          <Box className="lytPageWrapper">
            <LytAboutPage></LytAboutPage>
          </Box>
        );
      } else {
        return (
          <Box className="lytPageWrapper">
            <LytHtmlPage data={this.state.selectedPageData}></LytHtmlPage>
          </Box>
        );
      }
    };

    const BuildLoadState = () => {
      if (this.state.loadState === "loaded") {
        return <div id="statePage">{BuildLoadedState()}</div>;
      }
      return <div id="statePage">{BuildLoadingState()}</div>;
    };

    const BuildLoadingState = () => {
      return <div id="loadingStatePage">page is loading..</div>;
    };

    const BuildFooter = () => {
      return (
        <div className="appFooter">
          <div className="cwNotice">&copy; 2025 Haru Tai</div>
          <div className="socLinks">
            <Stack direction="row" spacing={2}>
              <Tooltip title="Personal Instagram">
                <IconButton
                  className="socButton"
                  onClick={() => {
                    this.handleSocLink("instagram");
                  }}
                >
                  <InstagramIcon></InstagramIcon>
                </IconButton>
              </Tooltip>

              <Tooltip title="Tattoo Instagram">
                <IconButton
                  className="socButton"
                  onClick={() => {
                    this.handleSocLink("instagram2");
                  }}
                >
                  <InstagramIcon></InstagramIcon>
                </IconButton>
              </Tooltip>
            </Stack>
          </div>
        </div>
      );
    };

    const BuildLoadedState = () => {
      return (
        <ThemeProvider theme={theme}>
          <Box sx={{ flexGrow: 1 }} id="loadedStatePage">
            <Grid container sx={{ justifyContent: "center" }}>
              <Grid size={{ xs: 12, sm: 10, md: 8 }}>
                <header className="App-header">
                  <Grid container sx={{ justifyContent: "center" }}>
                    <Grid size={{ xs: 10, sm: 8, md: 6 }}>
                      <img id="headerLogo" src="./Images/logo.png" alt=""></img>
                      <h1 id="masterTitle">HARU TAI</h1>
                    </Grid>
                  </Grid>
                </header>
                <LytNavTabs
                  data={this.pagesData as PagesData}
                  onChange={this.handlePageNav}
                ></LytNavTabs>
                {BuildLytPage()}
              </Grid>
            </Grid>
          </Box>
          {BuildFooter()}
        </ThemeProvider>
      );
    };

    return <div className="App">{BuildLoadState()}</div>;
  }
}

export default App;
